import { z } from "zod";
import { CodeSchema } from "./Codes";

export const UserPermissionsSchema = z.object({
  administrator: z.boolean().default(false),
  drawAssistant: z.boolean().default(false),
  printReports: z.boolean().default(false),
  hideFinancialDataDefault: z.boolean().default(false),
  manageUserGroups: z.boolean().default(false),
  managePropertyTypes: z.boolean().default(false),
  addProject: z.boolean().default(false),
  editProject: z.boolean().default(false),
  deleteProject: z.boolean().default(false),
  archiveProject: z.boolean().default(false),
  restoreProject: z.boolean().default(false),
  modifyAfterDrawZero: z.boolean().default(false),
  hideFinancialDataProject: z.boolean().default(false),
  addEntity: z.boolean().default(false),
  editEntity: z.boolean().default(false),
  deleteEntity: z.boolean().default(false),
  addLedger: z.boolean().default(false),
  editLedger: z.boolean().default(false),
  deleteLedger: z.boolean().default(false),
  voidTransaction: z.boolean().default(false),
  processSelectedTasks: z.boolean().default(false),
  reconcileProjects: z.boolean().default(false),
  manualImport: z.boolean().default(false),
  manualExport: z.boolean().default(false),
  addDraw: z.boolean().default(false),
  completeDraw: z.boolean().default(false),
  approveAll: z.boolean().default(false),
  approveWithActualVariance: z.boolean().default(false),
  approveWithRedNetEstVariance: z.boolean().default(false),
  approveWithRedNetEstVarianceAmt: z.boolean().default(false),
  approveLienWaivers: z.boolean().default(false),
  voidTransactionDraw: z.boolean().default(false),
  rollbackDraw: z.boolean().default(false),
  fundDraw: z.boolean().default(false),
  approveClean: z.boolean().default(false),
  addLienWaiverDescriptions: z.boolean().default(false),
  processSelectedTasksDraw: z.boolean().default(false),
});

export const UserDetailSchema = z.object({
  userId: z.string(),
  entityId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  userName: z.string(),
  userGroup: CodeSchema.nullable(),
  administrator: z.boolean(),
  drawAssistant: z.boolean(),
  lastPasswordChangeDate: z.string().nullable(),
  passwordExpirationDate: z.string().nullable(),
  lastLogin: z.string().nullable(),
  lastFailedLogin: z.string().nullable(),
  active: z.boolean(),
  locked: z.boolean(),
  user: z.boolean(),
  permissions: UserPermissionsSchema,
  email: z.string(),
});

export const UserDetailListSchema = z.array(UserDetailSchema);

export type UserDetail = z.infer<typeof UserDetailSchema>;
export type UserPermissions = z.infer<typeof UserPermissionsSchema>;
